import { InjectionToken } from '@angular/core';
import { ITokenModel } from '../token/interface';
import { STORE_TOKEN_LOCAL_FACTORY } from './local-storage.service';

export const AUTH_STORE_TOKEN = new InjectionToken<IStore>('AUTH_STORE_TOKEN', {
  providedIn: 'root',
  factory: STORE_TOKEN_LOCAL_FACTORY,
});

export interface IStore {
  /**
   * LocalStorageからトークン情報を取得する
   */
  get(key: string): ITokenModel;
  /**
   * LocalStorage中のトークン情報を更新する
   */
  set(key: string, value: ITokenModel): boolean;
  /**
   * LocalStorage中のトークン情報をクリアする
   */
  remove(key: string): void;
}
